module.exports = __webpack_public_path__ + "stratumBlue-icon.svg?5dd0756ca4f1c3aea3a884a907c9ee49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stratumBlue-icon.svg
// module id = 976
// module chunks = 2